export const paymentMethods = {
  paypal: 'paypal',
  card: 'card',
  sofort: 'sofort',
  free: 'free',
  applePay: 'applePay',
  googlePay: 'googlePay',
  iDeal: 'ideal',
};

export const paymentMethodsV2 = {
  paypal: 'paypal',
  stripe: 'stripe',
  preSavedCard: 'preSavedCard',
  free: 'free',
};

export const customCardPaymentId = 'custom';

export const productTypes = {
  tees: 'tees',
  stickers: 'stickers',
  prints: 'prints',
  sweater: 'sweater',
};

export const defaultCountryCode = 'XX';
export const allCountriesCode = 'all';

export const googleMapsApiKey = 'AIzaSyBAKmGht73lLsmfIZGrGGtR5jyE_UULncg';
